<template>
    <div class="modal" :class="{'modal-over' : expanded}">
        <div class="modal-content">
            <div class="modal-header" v-if="!expanded">
                <div class="modal-header-title">
                  <span v-if="props.title">{{Language.say(props.title)}}</span>
                  <slot name="title"></slot>
                </div>
                <div @click="onClickClose()" class="modal-header-close" id="modal-close"><span></span></div>
            </div>

            <slot name="pre-body" v-if="!expanded"> </slot>

            <div :class="{'modal-body': !expanded}"  v-smart-render-scroll>
                 <slot v-if="loading">
                    <div class="modal-body"  v-smart-render-scroll>
                        <ContentLoading/>
                    </div>
                  </slot>


                  <slot name="body" v-else></slot>
            </div>

            <slot name="post-body" v-if="!expanded"> </slot>

            <div class="modal-footer clearfix" v-if="!expanded">
                <slot name="footer"> </slot>
            </div>
        </div>
    </div>
</template>

<script setup>
  import {ref}                                    from "vue";
  import {defineEmits, defineExpose, defineProps} from "vue";
  import {onBeforeMount, onUnmounted}             from "vue";
  import { KeyboardProfile }                      from "@/js/Webmail/Keyboard/KeyboardMetadata";
  import KeyboardController                       from "@/js/Webmail/Keyboard/KeyboardController";
  import Language                                 from "@/js/Shared/Language/Language";
  import ContentLoading                           from "@/vue/Elements/Content/ContentLoading.vue";
  import GTMAnalyticsController                   from "@/js/Webmail/Analytics/GTMAnalyticsController";


  const props = defineProps({
    title : {
      default: '',
    },

    loading : {
      type: Boolean,
      default: false,
    },

    gtm: {
      default : null,
    }
  })

  const expanded = ref(false);
  const id       = Date.now();

  onBeforeMount(() => {
    KeyboardController.disableAll();
    KeyboardController.create(KeyboardProfile.SIMPLE_MODAL, {
      close : onKeyEscape,
    })
  });

  onUnmounted(() => {
    KeyboardController.delete(KeyboardProfile.SIMPLE_MODAL);
    KeyboardController.enableAll();
  });

  const emit = defineEmits([
    'modalWindowClose',
  ]);

  const onKeyEscape = () => {
    close();
  }

  const onClickClose = () => {
    close();
  }

  const expand = (value) => {
    expanded.value = value;
  }

  const close = () => {
    if (props.gtm) {
      GTMAnalyticsController.postTrackerLink(
        props.gtm.module,
        props.gtm.feature,
        props.gtm.block,
        props.gtm.action
      );
    }

    emit('modalWindowClose')
  }

  defineExpose({
    expand,
    close,
  });
</script>